import MeetTheMembersPage from "../pages/MeetTheMembersPage";
import VideoSlider from "./VideoSlider";

const TestComponent = () => {
  const sampleVideoIds = [
    "dQw4w9WgXcQ",
    "3JZ_D3ELwOQ",
    "L_LUpnjgPso",
    "dQw4w9WgXcQ",
    "3JZ_D3ELwOQ",
    "L_LUpnjgPso",
    "dQw4w9WgXcQ",
    "3JZ_D3ELwOQ",
    "L_LUpnjgPso",
    "dQw4w9WgXcQ",
    "3JZ_D3ELwOQ",
    "L_LUpnjgPso",
  ];
  return (
    <>
      <VideoSlider videoIds={sampleVideoIds} />
      <MeetTheMembersPage t={""} />
    </>
  );
};

export default TestComponent;
